import React from 'react'

const CollectionLabel = ({ state }) => {
    return (
        <div className='text-sm'>
            {state ? `${state?.collectionCode}, ${state?.collectionName}` : ""}
        </div>
    )
}

export default CollectionLabel